import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetBanners = createAsyncThunk<AxiosResponse<any, any>, any>(
  "hero/toGetBanners",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/home-slider?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
